import React, {Component} from 'react';
import {NavBar} from 'antd-mobile';
import "./style.less";
export default class Security extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render(){
        return(
            <div className="security">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >安全中心</NavBar>
                <div className="content">
                    <div className="topCon">
                        <p className="tit">谎报警情，依法追责</p>
                        <p className="text">谎报警情将可能被处以五日以上十日以下拘留</p>
                    </div>
                    <div className="middle">
                        <div className="box">
                            <i className="icon iconfont iconjinjilianxirentubiao"/>
                            <div className="con">
                                <div className="tit">紧急联系人</div>
                                <div  className="text">如遇险情，我们将及时通知您的紧急联系人。</div>
                            </div>
                            <span onClick={()=>this.props.history.push('contacts')}>修改</span>
                        </div>
                        <div className="box">
                            <i className="icon iconfont iconyinsimimabaohu"/>
                            <div className="con">
                                <div className="tit">隐私号码保护</div>
                                <div  className="text">号码采用技术加密，保障用户隐私！</div>
                            </div>
                        </div>
                    </div>
                    <a className="callBuy" href={"tel:110"}><button>呼叫110</button></a>
                    <p>民途出行，守护您的每一次出行</p>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Home/Security/index.js